import api from './index';

let exports = {};

exports.getServcCatTreeList = function (params, callback) {// 查询服务分类树列表
    api.post('/servc/categ/tree/list/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
//服务分类tree
exports.getServcCatTreeListByFilter = function (params, callback) {// 获取服务分类树形列表
    api.post('/servc/categ/tree/list/get/by/filter')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 根据父id获取分类信息
exports.getServcCatListByParentId = function (params, callback) {
    api.post('/servc/categ/list/get/by/parentId')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getServcCat = function (params, callback) {// 获取商品分类信息
    api.post('/servc/categ/get')
    .data(params)
    .done(callback)
    .go();
};

// =========================== 服务分类属性设置 =======================
// 获取属性
exports.getServcCatAttrList = function (params, callback) {// 条件查询服务分类属性列表
    api.post('/servc/categ/attr/list/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 更新属性
exports.saveServcCatAttr = function (params, callback) {// 保存服务分类属性
    api.post('/servc/categ/attr/save/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

// 获取属性详细信息
exports.getServcCatAttr = function (params, callback) {// 获取服务分类属性
    api.post('/servc/categ/attr/get')
    .data(params)
    .done(callback)
    .go();
};
// 删除属性
exports.deleteServcCatAttr = function (params, callback) {// 删除服务分类属性信息
    api.post('/servc/categ/attr/delete/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// ==============  服务属性项 ===============
// 获取属性项列表
exports.getServcCatAttrOptionList = function (params, callback) {// 条件查询服务分类属性项列表
    api.post('/servc/categ/attr/option/list/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 获取属性项 详细信息
exports.getServcCatAttrOption = function (params, callback) {// 获取服务分类属性项
    api.post('/servc/categ/attr/option/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 更新属性项
exports.saveServcCatAttrOption = function (params, callback) {// 保存服务分类属性项信息
    api.post('/servc/categ/attr/option/save/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 通过分类catId获取分类属性及属性项
exports.getServcCatAttrListByCatIdAndMerchtId = function (params, callback) {// 获取分类属性及属性项列表
    api.post('/servc/categ/attr/list/get/by/catId/and/merchtId')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 删除服务属性项
exports.deleteServcCatAttrOption = function (params, callback) {// 删除服务分类属性项信息
    api.post('/servc/categ/attr/option/delete/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

// ===============  服务属性分组 ==================
//
exports.getServcCatPropGroupList = function (params, callback) {// 条件查询服务分类_属性分组信息
    api.post('/servc/categ/prop/group/list/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

//
exports.setServcCatPropBelongGroup = function (params, callback) {// 设置服务属性所属分组
    api.post('/servc/categ/prop/belong/group/set/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

// =================== 通过分类catId获取服务分类品牌列表 ==========================
exports.getServcCatBrandList = function (params, callback) {// 获取服务分类品牌列表
    api.post('/servc/categ/brand/list/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getAuthServcBrandBrandIds = function (data, callback) { // 获取授权品牌的BrandIds
    api.post('/servc/categ/auth/servc/brand/brandIds/get')
    .data(data)
    .done(callback)
    .go();
};
exports.getGlobalBrand = function (data, callback) {
    api.post('/servc/categ/servc/global/brand/get')
    .data(data)
    .done(callback)
    .go();
};

// ----------------- 商户常用服务分类 ------------------------------
exports.getMerchtFusedServcCatList = function (data, callback) {// 查询商户常用服务分类列表
    api.post('/servc/categ/mercht/fused/servc/cat/list/get')
    .data(data)
    .done(callback)
    .go();
};
exports.getMerchtFusedServcCatPageList = function (data, callback) {// 查询商户常用服务分类列表
    api.post('/servc/categ/mercht/fused/servc/cat/page/list/get')
    .data(data)
    .done(callback)
    .go();
};
exports.getMerchtFusedServcCatById = function (params, callback) {// 查询商户常用服务分类
    api.get('/servc/categ/mercht/fused/servc/cat/get/by/id')
    .params(params)
    .done(callback)
    .go();
};
exports.getMerchtFusedGoodsCatByCatIds = function (data, callback) {// 根据分类查询商户常用分类
    api.post('/servc/categ/mercht/fused/servc/cat/list/get/by/servc/or/goodsId/or/goodsCatId')
    .data(data)
    .done(callback)
    .go();
};

exports.saveMerchtFusedServcCat = function (data, callback) {// 保存商户常用服务分类
    api.post('/servc/categ/mercht/fused/servc/cat/save/do')
    .data(data)
    .done(callback)
    .go();
};
exports.deleteMerchtFusedServcCat = function (data, callback) {// 删除商户常用服务分类
    api.post('/servc/categ/mercht/fused/servc/cat/delete/do')
    .data(data)
    .done(callback)
    .go();
};
exports.moveMerchtFusedServcCat = function (data, callback) {// 删除商户常用服务分类
    api.post('/servc/categ/mercht/fused/servc/cat/move/do')
    .data(data)
    .done(callback)
    .go();
};
exports.getMerchtFusedServcCatListByMerchantId = function (data, callback) {// 查询商户常用服务分类
    api.post('/servc/categ/mercht/fused/servc/list/get/by/merchantId')
    .data(data)
    .done(callback)
    .go();
};

// ================ 评价 ====================

// 获取标签
exports.getServcCatEvalTagList = function (postData, callback) {// 获取评价标签列表
    api.post('/servc/categ/eval/tag/list/get')
    .data(postData)
    .done(callback)
    .go();
};
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/servcCateg.js
// module id = 25
// module chunks = 1